import { styled } from "../../../../lib/styled";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

interface StepRowProps {
  label: string;
  subMessage: string;
  status: "pending" | "active" | "done";
}

const StepWrapper = styled("div")<{ $status: StepRowProps["status"] }>(({ $status }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
  opacity: $status === "pending" ? 0.35 : 1,
  transition: "opacity 0.5s ease",
  marginBottom: "20px",
}));

const StepIconSlot = styled("div")({
  marginTop: "1.6px",
  width: 20,
  flexShrink: 0,
});

const StepContent = styled("div")({});

const StepLabel = styled(Typography)<{ $active: boolean }>(({ $active }) => ({
  fontWeight: $active ? 600 : 400,
  transition: "font-weight 0.3s",
}));

const PendingIcon = styled(RadioButtonUncheckedIcon)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

export function StepRow({ label, subMessage, status }: StepRowProps) {
  return (
    <StepWrapper $status={status}>
      <StepIconSlot>
        {status === "done" && <CheckCircleIcon color="primary" fontSize="small" />}
        {status === "active" && <CircularProgress size={18} color="primary" />}
        {status === "pending" && <PendingIcon fontSize="small" />}
      </StepIconSlot>
      <StepContent>
        <StepLabel variant="body1" component="div" $active={status === "active"}>
          {label}
        </StepLabel>
        {status === "active" && subMessage && (
          <Typography variant="caption" color="text.secondary">
            {subMessage}
          </Typography>
        )}
      </StepContent>
    </StepWrapper>
  );
}
